/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { ConfigService } from './config/config.service';
import { firstValueFrom, Observable, of } from 'rxjs';
import { OrganizationInterface } from '../plasma-ui-common/interfaces/organization.interface';
import { OrganizationService as LibOrganizationService } from '../plasma-ui-common/synlab-access-ui-components/core/organization/organization.service';
import { Constants } from '../components/indigo-yellow-ui/constants';
import { ResponseInterface } from '../components/indigo-yellow-ui/interfaces/response.interface';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService implements LibOrganizationService {
  public readonly selectedOrg = signal<string>('');

  public organizations$: Observable<OrganizationInterface[]> = of([]);

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {}

  public getAll() {
    const request = this.http.get<OrganizationInterface[]>(
      `${this.configService.baseAuthUrl}/api/organizations`,
    );
    return firstValueFrom(request);
  }

  public async getUserOrgs(userId: string, synlabId: string) {
    const request = this.http.get<OrganizationInterface[]>(
      `${this.configService.baseAuthUrl}/api/organizations/select-user-org`,
      {
        params: {
          userId,
          synlabId,
        },
      },
    );
    return firstValueFrom(request);
  }

  public async loadCurrentOrganization(): Promise<OrganizationInterface | null> {
    try {
      const organization = await this.getUserSessionOrg();
      if (organization?.organizationId) {
        this.selectedOrg.set(organization?.organizationId);
      }
      return organization;
    } catch (error) {
      console.dir(error);
      console.log('Error fetching latest selected org', error);
      return null;
    }
  }

  public async getUserSessionOrg() {
    const request = this.http.get<OrganizationInterface>(
      `${this.configService.baseAuthUrl}/api/organizations/latest-selected-org`,
    );
    return firstValueFrom(request);
  }

  public saveOrgId(orgId: string) {
    const { BaseAuthUrl } = this.configService.envConfig;
    const url = Constants.saveOrgUrl.replace('[selectedOrgHere]', orgId);
    const request = this.http.post<ResponseInterface<{ synlabId: string; userId: string }>>(
      `${BaseAuthUrl}${url}`,
      {},
    );
    return firstValueFrom(request);
  }

  public async doSaveOrgId(orgId: string) {
    await this.saveOrgId(orgId);
    window.location.reload();
  }
}
